module.exports = "/assets/side-events-listing/banner.png?pa8O/mi";